import { Main } from '@/layouts/main';
import { mdxToHtml } from '@/lib/mdx';
import sanityClient from '@/lib/sanityClient';
import { aboutQuery } from '@/lib/sanityQueries';
import { GetStaticProps, NextPage } from 'next';
import { MDXRemote, MDXRemoteProps } from 'next-mdx-remote';
import Head from 'next/head';

interface Props {
  title: string;
  content: MDXRemoteProps;
}

const about: NextPage<Props> = ({ title, content }) => {
  return (
      <>
      <Head>
      <title>chrisbailey.dev - about</title>
      <meta name="description" content="short introduction to who chris bailey is."/>
      
      </Head>
      <Main>
      <article className="mx-auto max-w-none prose">
      <h2 className="text-3xl text-indigo-600 lowercase">{title}</h2>
      <MDXRemote {...(content as MDXRemoteProps)} />
      </article>
      </Main>
      </>
  );
};

export const getStaticProps: GetStaticProps = async (context: any) => {
  const about = await sanityClient.fetch(aboutQuery);
  const { html } = await mdxToHtml(about.description);
  return {
    props: {
      title: about.title,
      content: html
    }
  };
};

export default about;
